import CommonModal from 'components/common/CommonModal';
import ScreenLayout from 'components/common/ScreenLayout';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import Pagination from 'components/common/Pagination';
import moment from 'moment-timezone';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {userInfoState} from 'utils/Atoms';
import {
  deleteRerralCode,
  searchBackOfficeSalesManagerList,
} from 'function/api';
import {convertTotalPage} from 'function/converter';
import {formatPhoneNumber} from 'utils/fomatPhoneNumber';
import ContainerHeader from 'components/common/ContainerHeader';
import RegisterReferralCodeModal from 'components/salesManagement/RegisterReferralCodeModal';
import DiscardCodeModal from 'components/salesManagement/DiscardCodeModal';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultButton from 'components/common/DefaultButton';

const SalesManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});

  const navigate = useNavigate();

  const userInfo = useRecoilValue(userInfoState);

  const [requestTongCurrentPage, setRequestTongCurrentPage] = useState(1);
  const [requestTongTotalPage, setRequestTongTotalPage] = useState(1);

  const [requestTongData, setRequestTongData] = useState<null | any>(null);

  const [modal, setModal] = useState('');

  const [selectItem, setSelectItem] = useState<null | any>(null);

  const [total, setTotal] = useState(1);

  const modalData: {[key: string]: any} = {
    // 본사시스템 서비스 준비중
    servicePreparing: {
      title: 'servicePreparing',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
      },
    },

    deleteCode: {
      title: '추천 코드를 삭제하시겠습니까?',
      firstButtonText: 'confirm',
      secondButtonText: 'cancel',
      firstButtonClick: async () => {
        const result = await deleteRerralCode({
          userInfo,
          setIsLoading,
          setErrorModal,
          referralCodeUUID: selectItem?.referralCode?.uuid,
        });
        if (result) {
          setModal('');
          window.location.reload();
        }
      },
      secondButtonClick: () => setModal(''),
    },
  };

  useEffect(() => {
    if (!userInfo?.accessToken) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    if (userInfo?.accessToken) {
      searchBackOfficeSalesManagerList({
        userInfo,
        setErrorModal,
        setIsLoading,
        page: requestTongCurrentPage,
      }).then(result => {
        if (result) {
          setRequestTongData(result);

          const resTotalPage = convertTotalPage(result.totalCount ?? 0, 10);
          setRequestTongTotalPage(resTotalPage);
          setTotal(result.totalCount);
        }
      });
    }
  }, [userInfo, requestTongCurrentPage]);

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader mainTitle="salesManagement" />

        <Inner>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: minmax(30),
            }}>
            <div>
              <DefaultText
                text="salesManagerList"
                textStyle={{
                  fontSize: minmax(25),
                  fontWeight: 'bold',
                  borderBottom: `3px solid ${colors.primary}`,
                  width: 'fit-content',
                  marginBottom: minmax(20),
                }}
              />
            </div>
            <DefaultButton
              text={'파트너 등록'}
              buttonStyle={{
                width: 'fit-content',
                backgroundColor: colors.primary2,
                padding: minmax(30),
              }}
              textStyle={{color: 'white'}}
              onClick={() => navigate('/registerSales')}
            />
          </div>
          <ResultArea>
            <ResultHeader>
              <DefaultText
                text=""
                textStyle={{
                  ...ResultHeaderTextStyle,
                  flex: 0.4,
                }}
              />
              <DefaultText
                text="referralCode"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="salesPartnerCompanyName"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="managerName"
                textStyle={ResultHeaderTextStyle}
              />
              <DefaultText
                text="phone"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="email"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />

              <DefaultText
                text="registrationDate"
                textStyle={ResultHeaderTextStyle}
              />
              <DefaultText
                text="상태"
                textStyle={{...ResultHeaderTextStyle, flex: 1}}
              />

              <DefaultText
                text="상세"
                textStyle={{...ResultHeaderTextStyle, flex: 1}}
              />
            </ResultHeader>

            <ResultList>
              {requestTongData?.totalCount ? (
                requestTongData.userProfiles.map((item: any, index: number) => (
                  <ResultItem
                    key={item.uuid}
                    onClick={() => {
                      //
                    }}>
                    <DefaultText
                      text={(
                        total -
                        ((requestTongTotalPage - 1) * 10 + index)
                      ).toString()}
                      textStyle={{...ResultHeaderTextStyle, flex: 0.4}}
                    />
                    <DefaultText
                      text={item?.referralCode?.code || '미발행'}
                      textStyle={{
                        ...ResultItemStyle,
                        flex: 1.5,
                        color: item?.referralCode?.code
                          ? colors.black
                          : colors.vividRed,
                        cursor: 'pointer',
                      }}
                      onClick={() => setSelectItem({...item, type: 'register'})}
                    />
                    <DefaultText
                      text={item.salesPartnerCompanyName || '-'}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={item.name || '-'}
                      textStyle={ResultItemStyle}
                    />
                    <DefaultText
                      text={
                        item.phone
                          ? formatPhoneNumber({
                              phone: item.phone,
                              locale: item.locale,
                            })
                          : '-'
                      }
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={item.email || ''}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={moment(item.createdAt).format('YY-MM-DD')}
                      textStyle={ResultItemStyle}
                    />

                    <DefaultText
                      text={
                        item?.deletedAt
                          ? '삭제'
                          : item?.isBlock
                          ? '정지'
                          : '등록'
                      }
                      textStyle={{
                        ...ResultItemStyle,
                        flex: 1,
                        color: item?.isBlock ? colors.primary : colors.black,
                      }}
                    />
                    <div
                      style={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        navigate('/salesManagerDetail', {
                          state: item?.owner?.uuid,
                        })
                      }>
                      <DefaultImageView
                        source="images/common/left_arrow.png"
                        style={{
                          transform: 'scaleX(-1)',
                          height: minmax(50),
                        }}
                      />
                    </div>
                  </ResultItem>
                ))
              ) : (
                <DefaultText
                  text="-"
                  textStyle={{
                    color: colors.darkGray,
                    textAlign: 'center',
                    margin: `${minmax(12)} 0`,
                  }}
                />
              )}
            </ResultList>
          </ResultArea>

          {requestTongData?.totalCount ? (
            <Pagination
              totalPage={requestTongTotalPage}
              currentPage={requestTongCurrentPage}
              setCurrentPage={setRequestTongCurrentPage}
            />
          ) : null}
        </Inner>
      </Container>

      {modal !== '' && (
        <CommonModal
          title={modalData[modal].title}
          detail={modalData[modal].detail}
          firstButtonText={modalData[modal].firstButtonText}
          firstButtonStyle={modalData[modal].firstButtonStyle}
          secondButtonText={modalData[modal].secondButtonText}
          secondButtonStyle={modalData[modal].secondButtonStyle}
          firstButtonClick={modalData[modal].firstButtonClick}
          secondButtonClick={modalData[modal].secondButtonClick}
          closeModal={modalData[modal].firstButtonClick}
        />
      )}

      {selectItem &&
        (selectItem?.type === 'register' ? (
          <RegisterReferralCodeModal
            selectItem={selectItem}
            closeModal={() => setSelectItem(null)}
            setIsLoading={setIsLoading}
            setErrorModal={setErrorModal}
          />
        ) : selectItem?.type === 'discard' ? (
          <DiscardCodeModal
            selectItem={selectItem}
            closeModal={() => setSelectItem(null)}
            setIsLoading={setIsLoading}
            setErrorModal={setErrorModal}
          />
        ) : (
          <></>
        ))}
    </ScreenLayout>
  );
};

export default SalesManagement;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(40)};
`;

const ResultArea = styled.div`
  margin-bottom: ${minmax(40)};
  border-bottom: 1px solid ${colors.darkGray};
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultList = styled.ul`
  /* height: 728px; */
  /* overflow-y: auto; */

  // 스크롤바 삭제
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const ResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${minmax(8)} 0;
  min-height: ${minmax(52)};
  border-top: 1px solid ${colors.lightGrey};
  &:last-child {
    border-bottom: none;
  }
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  // whiteSpace: 'nowrap',
  // wordBreak: 'break-all',
};
